const { ajaxHandler, toast, spinnerElem } = require("./utilities/utilities");

/**
 * Affiliate template script
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', function () {
    const { site_url, rest_url, nonce_value } = vendoraObject;
    const affiliateForm = document.getElementById('h5p-automator-become-affiliate-form');
    const affiliatePage = document.getElementById('h5p-automator-account-affiliate-page');

    const affiliatePaymentEmail = document.getElementById("affiliate_payment_email");
    const changeEmailButton = document.getElementById("change_affiliate_payment_email");
    const paymentEmailContent = document.getElementById("affiliate_payment_email_content");
    const paymentEmailForm = document.getElementById("affiliate_payment_email_form");

    const customLinkForm = document.querySelector('#affiliate-referral-link-form');
    const copyInput = document.querySelector('#vendora-affiliates-copy-input');
    const copyButton = document.querySelector('#vendora-affiliates-copy-button');

    if (affiliateForm) {
        affiliateForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                oldText = btnSubmit.innerHTML;

            if (!affiliateForm.checkValidity()) {
                return affiliateForm.classList.add("vendora-was-validated");
            }

            // Get form data
            const formData = new FormData(affiliateForm);
            try {
                btnSubmit.setAttribute('disabled', 'disabled');
                btnSubmit.innerHTML = spinnerElem;

                const post = await fetch(`${rest_url}/affiliates/apply`, {
                    headers: {
                        'X-WP-Nonce': nonce_value,
                    },
                    method: 'POST',
                    body: formData,
                });

                let resBody = await post.json();
                if (post.ok && 201 === resBody.status) {
                    toast.success(resBody.response);
                    setTimeout(() => {
                        window.location.href = `${site_url}/account/affiliates/`;
                    }, 1000);
                } else {
                    toast.error(resBody.response ?? resBody.message)
                }
            } catch (error) {
                toast.error('Something went wrong!');
                console.log(error)
            } finally {
                btnSubmit.removeAttribute('disabled');
                btnSubmit.innerHTML = oldText;
            }
        });
    }

    /**
     * Remove required attribute if checkbox is checked
     */
    const checkboxes = document.querySelectorAll('input[name="promotion_media[]"]');
    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            // Check if any checkbox is checked
            var anyChecked = Array.from(checkboxes).some(function (cb) {
                return cb.checked;
            });

            // Toggle the 'required' attribute based on whether any checkbox is checked
            checkboxes.forEach(function (cb) {
                cb.required = !anyChecked;
            });
        });
    });

    // Remove required checkbox if any checkbox is selected
    checkboxes.forEach(function (checkbox) {
        // Check if any checkbox is checked
        var anyChecked = Array.from(checkboxes).some(function (cb) {
            return cb.checked;
        });

        // Toggle the 'required' attribute based on whether any checkbox is checked
        checkboxes.forEach(function (cb) {
            cb.required = !anyChecked;
        });
    })

    if (affiliatePage) {
        // Show change email form
        changeEmailButton.addEventListener('click', () => {
            paymentEmailForm.classList.remove('vendora-d-none');
            paymentEmailContent.classList.add('vendora-d-none');
        });

        // Handle change payment email button click
        paymentEmailForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            if (!e.target.checkValidity()) {
                return e.target.classList.add("vendora-was-validated");
            }

            const formData = new FormData(e.target);
            formData.append('action', 'vendora_update_affiliate_withdrawal_settings');
            formData.append('payment_method', 'paypal');
            const res = await ajaxHandler(formData);
            const { success, data } = res;

            if (success) {
                paymentEmailForm.classList.add('vendora-d-none');
                paymentEmailContent.classList.remove('vendora-d-none');
                affiliatePaymentEmail.innerHTML = formData.get('payment_email');

                toast.success(data);
            }
        })

        // Copy affiliate URL to clipboard on click
        copyButton.addEventListener('click', (e) => {
            e.stopPropagation();
            if (copyInput) {
                navigator.clipboard.writeText(copyInput.value).then(() => {
                    toast.success('Copied to clipboard successfully!');
                }).catch(err => {
                    toast.error('Failed to copy');
                    console.error('Failed to copy: ', err);
                });
            }
        });

        // Handle generate URL
        customLinkForm.addEventListener('submit', (e) => {
            e.preventDefault();

            const uuid = e.target.elements.affiliate_uuid.value;
            let customUrl = e.target.elements.custom_link.value;

            if (!isValidUrl(customUrl)) {
                return toast.error(`Only URLs from ${site_url} is supported.`);
            }

            const url = new URL(customUrl);
            if (url.searchParams.has('affiliate')) {
                url.searchParams.delete('affiliate');
            }

            url.searchParams.set('affiliate', uuid);
            copyInput.value = url.href;

            document.querySelectorAll(".vendora-affiliates-social-share a").forEach((item) => {
                const socialUrl = new URL(item.href);
                if (socialUrl.host === "www.facebook.com") {
                    socialUrl.searchParams.delete('u');
                    socialUrl.searchParams.set('u', url.href);
                } else {
                    socialUrl.searchParams.delete('url');
                    socialUrl.searchParams.set('url', url.href);
                }
                item.href = decodeURIComponent(socialUrl.href);
            })
        })

        const isValidUrl = (url) => {
            const regex = new RegExp("^" + site_url);
            return regex.test(url);
        }
    }
});